export default __webpack_public_path__ + "static/media/YEM.8c301024.svg";